var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgError = function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 5.333C10.118 5.333 5.334 10.118 5.334 16S10.117 26.667 16 26.667c5.882 0 10.667-4.785 10.667-10.667S21.882 5.333 16 5.333Zm1.462 4.445-.573 8h-1.778l-.54-8h2.891ZM16 23.11a1.777 1.777 0 1 1 0-3.554 1.777 1.777 0 0 1 0 3.554Z",
    fill: "#D75C6F"
  })));
};
export default SvgError;